export default __webpack_public_path__ + "img/icon_right_arrow-56a907414a0a8a863b612d8824b8b98d.png";